import React from "react";
import {Switch} from "@progress/kendo-react-inputs";

export const Toggle = ({checked = false, ...otherProps}) => {

    return (
        <Switch
            checked={checked}
            {...otherProps}
        >
            {otherProps.children}
        </Switch>
    );
};
